export const namespaces = {
  common: "common",
  pages: "pages",
  viewer: "viewer",
};

export const LANGUAGE_LABELS = {
  cs: "Čeština",
  en: "English",
  de: "Deutsch",
  pl: "Polski",
};
